module.exports = __webpack_public_path__ + "img/project-cover.797fd05b.png";